<template>
  <span class="burger-highlight relative h-[26px] min-w-0 flex-1 bg-transparent"
        :data-title="props.title"></span>
</template>

<script setup>
const props = defineProps({
  title: {
    type: String,
    required: true
  }
})
</script>

<style scoped lang="scss">

.burger-highlight::before {
  background-color: #fbb665;
  color: #232227;
  content: attr(data-title);
  position: absolute;
  top: 0;
  left: 0;
  transform: skew(-14deg);
  font-weight: bold;
  font-family: 'Roboto', sans-serif;
  width: 100%;
  text-align: center;
  font-size: 18px;
  z-index: 10;
}

.step-active::before {
  @apply bg-primary-0 border border-secondary-0 text-secondary-0;
}

.step-done::before {
  @apply bg-secondary-0 border-secondary-0 border text-primary-0;
}

.step-inactive::before {
  @apply bg-transparent text-white;
}

</style>
